import VForm from '@/vuetify_custom/v-form'
import { VCard, VCardTitle, VCardText, VBtn } from 'vuetify/lib'
import VTable from '@/vuetify_custom/v-table/v3'
import NumberField from '@/vuetify_custom/v-form/components/Number_Field.js'
import VPopDel from '@/views/business/components/v-pop-del.vue'
import { common_mixins } from './EditMixIns.jsx'
import {createContractProducts, commonValidateRule} from '@/views/business/utils.js'
import {getThirdPartMallSubItemApi} from '@/views/business/service.js'
import styles from './index.module.less'
const commonValidateRuleGoone = commonValidateRule('必填')
export default {
    mixins:[common_mixins],
    computed: {
 
        table_fields() {
            return [
                {
                    text: '序号',
                    align: 'center',
                    value: 'index',
                    type: 'button_g_field',
                    width: 90,
                    fixed: 'left',
                    render: (_, __, index) => {
                        return <div>
                       <span >{index + 1}</span>
                    </div>
                    }
                },
                {
                    text: '子商品id',
                    align: 'center',
                    value: 'sub_item_id',
                    width: 100,
                    render:(_, value, __, ___, field) => {
                                        return <NumberField 
                                                    field = {{
                                                        key: field.value,
                                                        blur: (e) => {
                                                            getThirdPartMallSubItemApi({id:e.target.value}).then(res => {
                                                                
                                                                value.title = res.title
                                                            })
                                                      
                                                        },
                                                        rules: [commonValidateRuleGoone]
                                                    }}
                                            v-model={value}/>
                    }
                },
                {
                    text: '子商品名称',
                    align: 'center',
                    value: 'title',
                    width: 100,
                },
                {
                    text: '数量',
                    align: 'center',
                    // type: 'number_field',
                    value: 'qty',
                    width: 100,
                    render: (_, value, __, ___, field) => {
                        return <NumberField 
                                    field = {{
                                        key: field.value,
                                        rules: [commonValidateRuleGoone]
                                    }}
                                    v-model={value}/>
                    }
                },
                {
                    text: '单价',
                    align: 'center',
                    // type: 'number_field',
                    value: 'unit_price',
                    width: 100,
                    render: (_, value, __, ___, field) => {
                        return <NumberField 
                                    field = {{
                                        key: field.value,
                                        rules: [commonValidateRuleGoone]
                                    }}
                                    
                            v-model={value}/>
                    }
                },
                {
                    text: '券码有效期（个月）',
                    align: 'center',
                    // type: 'number_field',
                    value: 'effective_month',
                    width: 100,
                    render: (_, value, __, ___, field) => {
                        return <div>
                            <NumberField 
                                    field = {{
                                        key: field.value,
                                        rules: [commonValidateRuleGoone]
                                    }}
                            v-model={value}/>
                        </div> 
                    }
                },
                {
                    text: '操作',
                    align: 'center',
                    type: 'button_g_field',
                    // value: 'uid',
                     width: 120,
                     fixed: 'right',
                    render: (_, __, index) => {

                        if (this.params.contract_products && this.params.contract_products.length === 1) {
                            return 
                        }
                        return <VPopDel
                        title="确定删除该条数据？"
                        on={{
                            submit:() => {
                                this.params.contract_products.splice(index, 1)
                            }
                        }}
                    />
                    }
                }
            ]
        },
        fields() {
            return [
                {
                    key:'table',
                    cols: 12,
                },
            ]
        }
    },
    render() {
        const _this = this
        return <div class={styles['block-margin']}>
        <VCard flat light outlined>
            <VCardTitle>
                商品信息 <VBtn class={styles['btn-f']} 
                    outlined
                    color="primary"
                    small
                    on={{
                        click:() => {
                            if (!this.params.contract_products) {
                                this.params.contract_products = []
                            }
                            this.params.contract_products.push(createContractProducts())
                        }
                    }}
                    >
                    添加商品
                </VBtn>
            </VCardTitle>
            <VCardText>
            <VForm
                ref="base"
                fields={_this.fields}
                scopedSlots={{
                    table:() => {
                        return <VTable
                            headers={this.table_fields}
                            desserts={this.params.contract_products}
                            // scopedSlots={{
                            //     sub_item_id:(_, value, __, ___, field) => {
                            //           return <NumberField 
                            //           field = {{
                            //             key: field.value,
                            //             blur: (e) => {
                            //                 console.log('other', e.target.value)
                            //             }
                            //         }}
                            //           v-model={value}/>
                            //     }
                            // }}
                        />
                    }
                }}
            />
            </VCardText>
        </VCard>
    </div>
    }
}   